/**
 * WarehouseLocationFields — the building/section/row/stack 4-input grid,
 * shared by the Put-away and Move modals (3b-ii). Values are uppercased on
 * write by the backend; this component keeps them as typed. `value` is a
 * { building, section, row, stack } object; `onChange` receives the next object.
 */

import React from 'react';

const FIELDS = [
  { key: 'building', label: 'Building' },
  { key: 'section', label: 'Section' },
  { key: 'row', label: 'Row' },
  { key: 'stack', label: 'Stack' },
];

export default function WarehouseLocationFields({ value, onChange }) {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });
  return (
    <div className="wh-loc-grid">
      {FIELDS.map((f) => (
        <input
          key={f.key}
          className="wh-input"
          placeholder={f.label}
          value={value[f.key] || ''}
          onChange={set(f.key)}
        />
      ))}
    </div>
  );
}
